export const defaultHelpURL = 'https://diligent.com'

export const getBoardsHelpURL = (userLang: string) => {
    return `https://help.highbond.com/helpdocs/boards/${userLang}/Content/global_topics/index.htm?cshid=boards-standalone-help`
}
export const boardeffectURL = 'https://www.boardeffect.com/contact-support/'

export const getTtmUrl = (userLang: string) => {
    return `https://help.highbond.com/helpdocs/boards/${userLang}/Default.htm#cshid=boards-minutes-transcript-to-minutes`
}

export const getTemplateCustomizationUrl = (userLang: string) => {
    return `https://help.highbond.com/helpdocs/boards/${userLang}/Default.htm#cshid=boards-mins-customize-templates`
}

export const getLearnMoreURL = (userLang: string) => {
    return `https://help.diligent.com/diligenthelp/s/article/Data-processing-limitations-and-encryption-with-Diligent-AI?language=${userLang}`
}
